import Button from "components/common/Button";
import DialogConfirm from "components/common/DialogConfirm";
import { Plan } from "components/types/Types";
import { useHttpUtil } from "context/HttpContext";
import { usePermissionContext } from "context/Permission";
import Stats from "libs/utils/stats";
import { createContext, useContext, useState } from "react";
import Paypal from "./paypal";

interface PayContextObj {
  isProcessing: boolean,
  setIsCancelPlan: (isCancelPlan: boolean) => void,
  paypalSuccessHandler: (charge_id: string) => void
}
export const PayContext = createContext<PayContextObj|null>(null);

export function usePayContext() : PayContextObj | null{
  return useContext(PayContext);
}
  
  /**
   * 支付布局
   */
  export default function PayLayout(props: { children: React.ReactNode}){
    const { children } = props ;
    const httpUtil = useHttpUtil();
    const permissionContext = usePermissionContext();
    
    const [ isCancelPlan, setIsCancelPlan ] = useState<boolean>(false);
    const [ isCancelPlanSuc, setIsCancelPlanSuc ] = useState<boolean>(false);
    const [ isSubscribeSuc, setIsSubscribeSuc ]= useState<boolean>(false);

    const [ isProcessing, setIsProcessing] = useState<boolean>(false);

    const confirmCancel = async () => {
      setIsCancelPlan(false)
      setIsProcessing(true);
      const url = permissionContext?.isShopify ? '/api/cancel/subscribe' : '/biz/paypal/cancel' ;
      const resData = await httpUtil.post(url);
      if(!resData.errCode){
          let max = 25, curr = 0 ;
          let timer : NodeJS.Timeout ;
          timer = setInterval(async () => {
            const res = await httpUtil.post('/biz/plan/order/cancel/status');
            if(!res.errCode || curr ++ >= max){
              clearInterval(timer);
              setIsProcessing(false);
            }
            if(!res.errCode){
              permissionContext?.updator();
              setIsCancelPlanSuc(true);
            }
          }, 1500)
          return ;
      }
      setIsProcessing(false);
    }
    
    const confirmCancelSuc = () => {
      setIsCancelPlanSuc(false);
    }
    
    const confirmSubscribeSuc = () => {
      setIsSubscribeSuc(false);
    }

    const paypalSuccessHandler = (charge_id: string) => {
      setIsProcessing(true);

      let max = 25, curr = 0 ;
      let timer : NodeJS.Timeout ;
      timer = setInterval(async () => {
          const res = await httpUtil.post('/biz/plan/order/status',{
              shopifySubscriptionId : charge_id
          });
          if(!res.errCode || curr ++ >= max){
              clearInterval(timer);
              setIsProcessing(false);
          }
          if(!res.errCode){
              setIsSubscribeSuc(true);
              permissionContext?.updator();
          }
      }, 1500)
  }
    
    return (
        <PayContext.Provider value={{
          isProcessing,
          setIsCancelPlan,
          paypalSuccessHandler
        }}>
          { children }

          {
            isCancelPlan &&
            <DialogConfirm
                width={600}
                title="Are you sure you want to cancel your subscription?"
                content={[
                    'If you cancel your subscription, auto-renewal will be automatically turned off and no further charge will be made for the next month.',
                    'You can continue to use the remaining credits until the end of the subscription period, and the credits will be cleared at the end of the subscription period and automatically converted to the free plan.',
                    'If you want to check the expiration date of your subscription, you can do so by clicking on your account profile image and then clicking on "My Account".'
                ]}
                cancel={() => setIsCancelPlan(false)} confirm={() => confirmCancel()}></DialogConfirm>
            }
            
            {
              isCancelPlanSuc &&
                <DialogConfirm
                  width={600}
                  title="You have successfully unsubscribed !"
                  content={[
                      'Subscription details can be viewed by clicking on your account avatar and then clicking on “My Account”.'
                  ]}
                  confirm={confirmCancelSuc}></DialogConfirm>
            }
            {
              isSubscribeSuc &&
                <DialogConfirm
                  width={600}
                  title="You have successfully enabled auto-renewal !"
                  content={[
                      'Subscription details can be viewed by clicking on your account avatar and then clicking on “My Account”.'
                  ]}
                  confirm={confirmSubscribeSuc}></DialogConfirm>
            }

        </PayContext.Provider>
    )
  }


export function SubscribeButton(props: {txt: string, rounded ?: number, className ?: string, plan : Plan, isPaypalLarge ?: boolean}){
    const { txt, rounded, className, plan, isPaypalLarge = false } = props ;
    const httpUtil = useHttpUtil();
    const permissionContext = usePermissionContext();
    const payContext = usePayContext();


    const upgradePlan = async (plan: Plan) => {
      Stats.google('Upgrade Basic plan')
      const res = await httpUtil.post('/api/subscribe/' + plan.id, {});
      if(!res.errCode){
          location.href =  res.data.shopifyConfirmationUrl;
      }
    }

    return (
        <>
            {
              payContext?.isProcessing ?
                <Button txt={txt} isLoading={true} className={className} rounded={rounded} clickEvent={() => {}} />
              : 
                permissionContext?.isShopify ?
                  <Button txt={txt} className={className} rounded={rounded} clickEvent={() => upgradePlan(plan)} />
                :
                  <div className="relative">
                    <Button txt={txt} className={className} rounded={rounded} clickEvent={() =>{}} />
                    <div className={`absolute z-[10] left-[0px] top-[0px] opacity-[0.01] w-full h-full text-[0px] overflow-hidden` }
                      onClick={() => Stats.google('Upgrade Basic plan')}>
                      <Paypal plan={plan} onSuccessCallback={payContext?.paypalSuccessHandler} isLargeButton={isPaypalLarge}/>
                    </div>
                  </div>
            }
        </>
    )
}

export function SubscribeCancelButton(props: {txt ?: string, className ?: string, rounded ?: number}){
  const { txt = 'Unsubscribe', className,rounded }= props ;
  const payContext = usePayContext();

  const cancelPlan = () => {
    payContext?.setIsCancelPlan(true);
  }

  return (
    <>
      <Button txt={txt} className={className} rounded={rounded} isLoading={payContext?.isProcessing} clickEvent={cancelPlan} />
    </>
  )
}